import React from "react";
import { ExploreTheInterfaceStaticData, Images } from "../../utils/constant";
import Heading from "../common/heading";
import SubHeading from "../common/subheading";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { applyHoverAnimation } from "../../utils/animation"; // ✅ reuse hover helper
import "./style.css";
gsap.registerPlugin(ScrollTrigger, useGSAP);

const ExploreTheInterface = () => {
  const scopeRef = React.useRef<HTMLDivElement>(null);
  const cardsRef = React.useRef<HTMLDivElement[]>([]);
  const cardsContainerRef = React.useRef<HTMLDivElement>(null);

  useGSAP(
    () => {
      gsap.from(cardsRef.current, {
        y: 100,
        autoAlpha: 0,
        duration: 2,
        ease: "power3.out",
        stagger: 0.5,
        scrollTrigger: {
          trigger: cardsContainerRef.current,
          start: "top 80%",
          toggleActions: "play none none none",
          once: true,
        },
        onComplete: () => {
          // ✅ Floating + hover per image using unique selectors
          ExploreTheInterfaceStaticData.cards.forEach((_, index) => {
            const selector = `.hover-animate-${index}`;
            const tween = gsap.to(selector, {
              y: -25,
              duration: 1.5,
              ease: "power1.inOut",
              yoyo: true,
              repeat: -1,
              delay: index * 0.3, // stagger floating
            });
            const tweenRef = { current: tween }; // make a ref-like object
            applyHoverAnimation(selector, tweenRef);
          });
        },
      });
    },
    { scope: scopeRef }
  );

  return (
    <section
      ref={scopeRef}
      style={{
        backgroundImage: `linear-gradient(#0D264799, #0D264799), url(${Images.exploreTheInterfaceBg})`,
        boxShadow: "0px 2.67px 27.36px 0px #00000014",
        position: "relative",
      }}
      className="common-section-container"
    >
      <header className="common-heading-container">
        <Heading heading={ExploreTheInterfaceStaticData.heading} />
        <SubHeading subheading={ExploreTheInterfaceStaticData.subHeading} />
      </header>

      <div className="explore-interface-card-container" ref={cardsContainerRef}>
        {ExploreTheInterfaceStaticData.cards.map((card, index) => {
          return (
            <div
              key={index}
              className="explore-interface-card"
              ref={(el) => {
                if (el) {
                  cardsRef.current[index] = el as HTMLDivElement;
                }
              }}
            >
              <img
                src={card.image}
                alt={card.heading}
                className={`explore-interface-card-image hover-animate-${index}`} // ✅ unique class
              />
              <p className="explore-interface-card-heading">{card.heading}</p>
            </div>
          );
        })}
      </div>

      <img
        src={Images.dotImage}
        className="explore-interface-dot-image"
        alt="dot"
      />
    </section>
  );
};

export default ExploreTheInterface;
